import React, { useState } from 'react';
import { FaGithub, FaExternalLinkAlt, FaYoutube } from 'react-icons/fa';
import LightBoxGallery from './LightBoxGallery';

const ProjectsCard = ({ data }) => {
    const { title, img,images, pre, github, videoLink } = data;
    const [isOpen, setOpen] = useState(false);
    return (
        <div className="col-12 col-md-6 col-lg-4">
            <div className="projects-card">
                <div className="card-images" onClick={() => setOpen(true)}>
                    <img src={img && img} alt="title" />
                </div>
                <div className="proj-desc">
                    <div>
                        <h5 className="title">{title}</h5>
                        <div className="desc-btn">
                            <div className="projects-button d-flex justify-content-center flex-wrap">
                                <a className="proj-btn" rel="noreferrer" href={pre} target="_blank"><FaExternalLinkAlt /> Preview</a>
                                <a className="proj-btn" rel="noreferrer" href={github} target="_blank"><FaGithub />  Code</a>
                                {videoLink && videoLink !== '' &&
                                    <a className="proj-btn" rel="noreferrer" href={videoLink} target="_blank"><FaYoutube />Video</a>
                                }
                                <LightBoxGallery
                                    images={images}
                                    isOpen={isOpen}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ProjectsCard;

